import React from 'react';
import { IconInfoSolid32 } from '@croquiscom/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

import { LayoutRow } from '../Layout/LayoutRow';

export interface GuideProps extends React.HTMLProps<HTMLDivElement> {
  title?: string;
  className?: string;
  titleAlign?: 'left' | 'center' | 'right';
}

export const Guide = ({ children, className, title, titleAlign = 'center' }: GuideProps) => {
  return (
    <Container className={className}>
      {title && (
        <TitleWrapper titleAlign={titleAlign}>
          <span>
            <GuideIcon>
              <IconInfoSolid32 width={16} height={16} color={'iconSecondary'} />
            </GuideIcon>
          </span>
          <Title className={Typography.BODY_13_SEMIBOLD}>{title}</Title>
        </TitleWrapper>
      )}
      <Content className={Typography.BODY_13_MEDIUM}>{children}</Content>
    </Container>
  );
};

const Container = styled.div`
  padding: 16px 0;
  color: ${vars.color.textSecondary};
`;

const TitleWrapper = styled(LayoutRow)<{ titleAlign: 'left' | 'center' | 'right' }>`
  display: flex;
  align-items: flex-start;
  justify-content: ${({ titleAlign }) => {
    switch (titleAlign) {
      case 'left':
        return 'flex-start';
      case 'right':
        return 'flex-end';
      case 'center':
      default:
        return 'center';
    }
  }};
`;

const GuideIcon = styled.figure`
  display: inline-block;
`;

const Title = styled.p`
  margin-left: 4px;
`;

const Content = styled.p`
  margin-top: 6px;
  line-height: 1.33;
`;
